export class Colors {
  static FRENCH_VIOLET = '#8503e3';
  static GRAY = '#bababa';
}
